const getDefaultApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      if (window.location.port !== '5000') {
        return `${window.location.protocol}//${window.location.hostname}:5000`;
      }
    }
    return `${window.location.protocol}//${window.location.host}`;
  }
  return '';
};

const normalizeBaseUrl = (url: string) => url.replace(/\/+$/, '');

const resolvedBaseUrl =
  process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.trim().length > 0
    ? normalizeBaseUrl(process.env.REACT_APP_API_URL.trim())
    : normalizeBaseUrl(getDefaultApiBaseUrl());

export const API_BASE_URL = resolvedBaseUrl;

export const buildApiUrl = (path: string) => {
  const cleanedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${cleanedPath}`;
};

